import { Component, OnInit, Inject, AfterViewInit, Input } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TabService } from "src/app/services/tab/tab.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "src/app/services/auth/auth.service";
import { PasswordMeterComponent } from "src/app/@shared/components";
import { ModalConfirmacaoSenhaComponent } from "src/app/@feature/configuracoes/configuracoes/manutencao-usuarios/modal-confirmacao-senha/modal-confirmacao-senha.component";
import { take } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
  selector: "app-modal-perfil",
  templateUrl: "./modal-perfil.component.html",
  styleUrls: ["./modal-perfil.component.scss"],
  providers: [TabService],
})
export class ModalPerfilComponent implements OnInit, AfterViewInit {
  @Input() parent: PasswordMeterComponent;
  codigoMDT: number;
  isLoading = true;
  passwordIsValid = false;

  nome: string;
  username: string;
  email: string;
  senha: string;
  repetirSenha: string;
  alterarsenha: boolean = false;
  hide: boolean = true;

  // perfilForm = new FormGroup({
  //   nome: new FormControl(),
  //   email: new FormControl()
  // });

  // @ViewChild('nrt', { static: true }) nrt: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalPerfilComponent>,
    public snackBar: MatSnackBar,
    private authService: AuthService,
    private router: Router,
    public dialog: MatDialog
  ) {
    (this.username = this.data.usuario.username),
      (this.nome = this.data.usuario.nome),
      (this.email =
        this.data.usuario.email === undefined ? "" : this.data.usuario.email);
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  alterarSenha() {
    this.alterarsenha = !this.alterarsenha;
  }

  submit() {
    if (!this.validarSenha()) {
      this.openSnackBar(
        "Preencha a senha corretamente!",
        "OK",
        3000,
        "danger-snackbar"
      );
      return;
    }

    if (this.nome !== "" && this.email !== "") {
      var obj = {
        nome: this.nome,
        usuario: this.username,
        email: this.email,
        password: this.senha,
      };

      this.authService.alterarDados(obj).subscribe(
        (response) => {
          this.openSnackBar("Dados alterados com sucesso!", "OK", 3000, "");
          const salt = btoa("sequoia");
          localStorage.setItem(btoa("nome"), `${btoa(this.nome)}${salt}`);
          localStorage.setItem(btoa("email"), `${btoa(this.email)}${salt}`);
        },
        (error) => {}
      );
    }
  }

  validarSenha() {
    if (this.alterarsenha) {
      if (
        this.senha === undefined ||
        this.senha === "" ||
        this.repetirSenha === undefined ||
        this.repetirSenha === "" ||
        this.senha.length < 6 ||
        this.repetirSenha.length < 6
      )
        return false;
      else if (this.senha !== this.repetirSenha) return false;
      else return true;
    }
    return true;
  }

  modalConfirmacaoSenha(data) {
    const dialogRef = this.dialog.open(ModalConfirmacaoSenhaComponent, {
      width: "550px",
      data: {
        data,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((response) => {
        if (response === 1) {
          this.router.navigate(["/dashboard"]);
        }
        if (response === 2) {
          window.location.reload();
        }
      });
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
